import React from 'react'
import { useTranslation } from 'react-i18next'
import { Gem } from 'lucide-react'

const DoubleBetsFeed = ({ bets = [] }) => {
  const { t } = useTranslation()

  const colorColumns = [
    {
      key: 'red',
      cardClass: 'border-red-400/35 bg-red-500/12'
    },
    {
      key: 'black',
      cardClass: 'border-white/20 bg-slate-900/45'
    },
    {
      key: 'green',
      cardClass: 'border-emerald-400/35 bg-emerald-500/12'
    }
  ]

  const safeBets = Array.isArray(bets) ? bets : []

  return (
    <div>
      <div className="grid gap-3 lg:grid-cols-3">
        {colorColumns.map((column) => {
          const columnBets = safeBets.filter((bet) => String(bet.color || '') === column.key)

          return (
            <div key={column.key} className="min-h-0">
              <div className="space-y-2 max-h-[360px] overflow-y-auto pr-1">
                {columnBets.map((bet, index) => (
                  (() => {
                    const betItems = Array.isArray(bet.bet_items) ? bet.bet_items : []
                    const hasItems = betItems.length > 0

                    return (
                  <div
                    key={`${bet.chat_id || 'anon'}-${column.key}-${index}`}
                    className={`rounded-xl border p-3 ${column.cardClass}`}
                  >
                    <div className="flex items-center justify-between gap-3">
                      <div className="flex items-center gap-2 min-w-0">
                        <img
                          src={bet.ava}
                          alt={bet.name}
                          className="w-9 h-9 rounded-full object-cover border border-white/20"
                        />
                        <div className="min-w-0">
                          <p className="text-sm text-white font-semibold truncate">{bet.name || t('double.common.player', 'Игрок')}</p>
                        </div>
                      </div>

                      <span className="inline-flex items-center gap-1 text-sm font-semibold text-accent-primary">
                        {Number(bet.sum || 0).toLocaleString()} <Gem className="w-4 h-4" />
                      </span>
                    </div>

                    {hasItems ? (
                      <div className="mt-3">
                        <div className="grid grid-cols-3 gap-2">
                          {betItems.map((item, itemIndex) => (
                            <div
                              key={`${item.id || itemIndex}-${bet.chat_id || 'anon'}`}
                              className="rounded-md border border-white/10 bg-dark-primary/60 p-1.5 flex flex-col items-center justify-center text-center"
                            >
                              <img
                                src={item.img}
                                alt={item.name}
                                className="w-full h-12 object-contain mx-auto"
                                loading="lazy"
                              />
                              <p className="mt-1 text-[10px] text-accent-primary inline-flex items-center justify-center gap-0.5 w-full">
                                {Number(item.cost || 0).toLocaleString()} <Gem className="w-3 h-3" />
                              </p>
                            </div>
                          ))}

                          {Number(bet.crystal || 0) > 0 && (
                            <div className="rounded-md border border-cyan-300/30 bg-cyan-500/10 p-1.5 flex flex-col items-center justify-center text-center">
                              <div className="w-full h-12 flex items-center justify-center">
                                <Gem className="w-6 h-6 text-cyan-200" />
                              </div>
                              <p className="mt-1 text-[10px] text-cyan-100 inline-flex items-center justify-center gap-0.5 w-full">
                                {Number(bet.crystal || 0).toLocaleString()} <Gem className="w-3 h-3" />
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : null}

                    {bet.win_skin && (
                      <div className="mt-3 rounded-lg border border-emerald-300/30 bg-emerald-500/10 p-2.5">
                        <p className="text-[11px] text-emerald-200 mb-2">
                          {t('double.feed.winSkin', 'Выиграл скин')}
                        </p>
                        <div className="flex items-center gap-2">
                          <img
                            src={bet.win_skin.img}
                            alt={bet.win_skin.name}
                            className="w-12 h-12 object-contain"
                            loading="lazy"
                          />
                          <div className="min-w-0">
                            <p className="text-xs text-white font-medium truncate">{bet.win_skin.name}</p>
                            <p className="text-xs text-emerald-200 inline-flex items-center gap-1">
                              {Number(bet.win_skin.cost || 0).toLocaleString()} <Gem className="w-3 h-3" />
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                    )
                  })()
                ))}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default DoubleBetsFeed
